import { useState, useEffect } from 'react';
import "../styles/Filters.css";

const Filters = ({ onClose, filters, setFilters, defaultFilters, onApplied,  onReset }) => {




  const [localFilters, setLocalFilters] = useState(filters);
  const [moreOpen, setMoreOpen] = useState(false); // ← НОВОЕ

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setLocalFilters(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleCheckboxChange = (e) => {             // ← НОВОЕ
    const { id, checked } = e.target;
    setLocalFilters(prev => ({ ...prev, [id]: checked }));
  };

  const applyFilters = () => {
    // если пришёл onApplied — используем его (он сбросит selectedComplexId),
    // иначе оставляем старое поведение
    if (typeof onApplied === "function") {
      onApplied(localFilters);
    } else {
      setFilters(localFilters);
    }
  };

  const resetFilters = () => {
    const nextFilters = {
      ...defaultFilters,
      excludePik: localFilters.excludePik,
      excludeGranel: localFilters.excludeGranel,
    };
    setLocalFilters(nextFilters);
    if (typeof onReset === "function") {
      onReset();
    } else {
      setFilters(nextFilters);
    }
  };

  // Положи это выше компонента Filters (или вверху файла)
  const buildQuarterOptions = (startYear = 2025, endYear = 2030, exclude = {}) => {
    const res = [];
    for (let y = startYear; y <= endYear; y++) {
      for (let q = 1; q <= 4; q++) {
        if (exclude[y]?.includes(q)) continue; // пропускаем исключённые
        res.push(`${q} кв ${y}`);
      }
    }
    return res;
  };

  // исключаем 1 и 2 кварталы 2025
  const DEADLINE_OPTIONS = buildQuarterOptions(2025, 2029, { 2025: [1, 2] });



  return (
    <div id="filter-panel">
      <div className="filter-panel-content">
        <div className="filter-header">
          <h3>Фильтры ЖК</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>



        <label>
          <span>Срок сдачи (до):</span>
          <select
            id="deadline"
            value={localFilters.deadline}
            onChange={handleChange}
          >
            <option value="">Не важно</option>
            <option value="сданные">Сданные</option>
            {DEADLINE_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </label>



        <label>
          <span>Количество комнат:</span>
          <select id="rooms" value={localFilters.rooms} onChange={handleChange}>
            <option value="">Любое</option>
            <option value="студия">Студия</option>
            <option value="1к">1к</option>
            <option value="2к">2к</option>
            <option value="3к">3к</option>
            <option value="4к">4к+</option>
          </select>
        </label>
        <label>
          <span>Цена от (млн):</span>
          <input
            type="number"
            id="priceFrom"
            value={localFilters.priceFrom}
            onChange={handleChange}
            inputMode="decimal"
          />
        </label>
        <label>
          <span>Цена до (млн):</span>
          <input
            type="number"
            id="priceTo"
            value={localFilters.priceTo}
            onChange={handleChange}
            inputMode="decimal"
          />
        </label>

        {/* Площадь */}
        <label>
          <span>Площадь от (м²):</span>
          <input
            type="number"
            id="areaFrom"
            value={localFilters.areaFrom}
            onChange={handleChange}
            inputMode="decimal"
          />
        </label>
        <div className="cityCategory"> 

          <label className="field cityCategoryField">
            <span>Город/область:</span>
            <select
              id="cityCategory"                // ← handleChange читает id — ок
              value={localFilters.cityCategory ?? ""}
              onChange={handleChange}
            >
              <option value="">Не важно</option>
              <option value="city">В городе</option>
              <option value="region">В области</option>
            </select>
          </label>
        </div>
        <div className="finishesMode"> 

          <label className="field finishesModeField">
            <span>Отделка:</span>
            <select
              id="finishesMode"                // ← handleChange читает id — ок
              value={localFilters.finishesMode ?? ""}
              onChange={handleChange}
            >
              <option value="">Не важно</option>
              <option value="none">Без отделки</option>
              <option value="with">С отделкой</option>
            </select>
          </label>
        </div>
        {/* ===== Ещё фильтры (collapsible) ===== */}
        <div className="more-filters">
          <button
            type="button"
            className={`mf-toggle ${moreOpen ? "open" : ""}`}
            onClick={() => setMoreOpen(v => !v)}
            aria-expanded={moreOpen}
            aria-controls="more-filters-content"
          >
            <span>Ещё фильтры</span>
            <span className="mf-icon">{moreOpen ? "▾" : "▸"}</span>
          </button>

          {moreOpen && (
            <div id="more-filters-content" className="mf-content">
              <label className="checkbox">
                <input
                  id="showYandex"
                  type="checkbox"
                  checked={!!localFilters.showYandex}
                  onChange={handleCheckboxChange}
                />
                <span>Показывать ЖК Яндекс</span>
              </label>

              <label className="checkbox">
                <input
                  id="onlyApartments"
                  type="checkbox"
                  checked={!!localFilters.onlyApartments}
                  onChange={handleCheckboxChange}
                />
                <span>Без апартаментов</span>
              </label>

              <label className="checkbox">
                <input
                  id="onlyCommercial"
                  type="checkbox"
                  checked={!!localFilters.onlyCommercial}
                  onChange={handleCheckboxChange}
                />
                <span>Только коммерция</span>
              </label>

              <label className="checkbox">
                <input
                  id="showVehicles"
                  type="checkbox"
                  checked={!!localFilters.showVehicles}
                  onChange={handleCheckboxChange}
                />
                <span>Показывать авто</span>
              </label>

              <label className="checkbox">
                <input
                  id="excludePik"
                  type="checkbox"
                  checked={!!localFilters.excludePik}
                  onChange={handleCheckboxChange}
                />
                <span>Скрыть ЖК ПИК</span>
              </label>

              <label className="checkbox">
                <input
                  id="excludeGranel"
                  type="checkbox"
                  checked={!!localFilters.excludeGranel}
                  onChange={handleCheckboxChange}
                />
                <span>Скрыть ЖК Гранель</span>
              </label>

              {/* сюда потом легко добавлять новые чекбоксы */}
            </div>
          )}
        </div>
        {/* ===== /Ещё фильтры ===== */}
        
        <button  id="applyFilters" onClick={applyFilters}>
          Применить
        </button>
        <button id="resetFilters" onClick={resetFilters}>
          Сбросить
        </button>
      </div>
    </div>
  );
};

export default Filters;
